<template>

  <el-row type="flex" justify="space-start" :gutter="20">
    <el-col :span="24">
      <div class="card-header">
        <h4 class="card-title">Enrol Customer</h4>
      </div>



          <el-form :inline="true" >
            <el-form-item label="Firstname" prop="firstname">
              <el-input placeholder="Firstname" v-model="customer.firstname" />
            </el-form-item>
            <el-form-item label="Lastname" prop="lastname">
              <el-input placeholder="Lastname" v-model="customer.lastname" />
            </el-form-item>
            <el-form-item label="Email" prop="email">
              <el-input placeholder="Email" v-model="customer.email" />
            </el-form-item>

    

            <el-form-item label="Course" prop="course"  >
                   <ApolloQuery
    :query="require('./getCourses.gql')"
   
  >
    <template slot-scope="{ result: { data } }">
      <!-- Loading -->
              <el-select v-if="data"
                size="large"
                class="form-group border-input"
                placeholder="Select Course"
                v-model="customer.enrollment"
              >
                <el-option
                  v-for="option in data.Product"
                  class="select-danger"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>              </template>
  </ApolloQuery>
            </el-form-item>
  <el-form-item>
        <el-button type="info" @click="doEnrollment()">Enrol</el-button>
      </el-form-item>
          </el-form> <pre>{{customer}}</pre> 
        <el-alert v-if="enrollmentSuccess" title="Enrollments complete" type="success"  show-icon :closable="true"></el-alert>
      
    </el-col>
  </el-row>

</template>
<script>
import httpClient from "../../httpClient";
export default {
   props: ['partner'],
  data() {
    return {
      loading: false,
      enrollmentSuccess:false,
      data: {},
      error: {},
      result: {},
      courses: [],
      customer: {},
    };
  },
  methods:{
     async doEnrollment(){
             let doneEnrollments= await httpClient.post(process.env.SERVERLESS_URL + "/customer/process", this.customer)
              if(doneEnrollments.request.status==200){
                  this.enrollmentSuccess=true; 
                  this.customer={}
              }
          
      }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Customers/New.vue